/* O INTERRUPTOR DAS PEÇAS — acende e apaga o card, em qualquer tela.
 *
 * ⚠️ POR QUE ISTO EXISTE COMO ARQUIVO PRÓPRIO: o botão `.pc-luz` é emitido
 *   pelo snippets/ettore-card-produto.liquid, que serve a home, a categoria e
 *   a página de produto. Mas o comportamento morava DENTRO do
 *   sections/ettore-colecao.liquid — então o interruptor só respondia na
 *   categoria. Na home o botão aparecia, bonito, e não fazia nada: nem
 *   apagava, nem acusava erro. Ele apontou em 16/08, e tinha razão.
 *   É a décima perda de portagem do projeto, com a mesma assinatura das
 *   outras nove: a peça chega, o que a faz viver não.
 *
 * ⚠️ DELEGAÇÃO NO DOCUMENTO, não na seção. Card pode entrar depois — pela
 *   gaveta, por uma seção que se redesenha, pela paginação. Ouvindo no
 *   documento, card novo já nasce funcionando.
 */
(function () {
  /* [30/08] os rótulos vêm do botão (data-lbl-*), que os lê do editor. Ele: "em vez
     de 'ver apagadas', quero 'apagar a categoria', e quando apago, 'acender'". */
  function rotuloLuz(g, acender) {
    return acender ? (g.getAttribute('data-lbl-apagar') || 'Apagar a categoria')
                   : (g.getAttribute('data-lbl-acender') || 'Acender a categoria');
  }
  if (window.__ettoreLuz) return;
  window.__ettoreLuz = true;

  /* aceso = SEM a classe .apagado — a foto de catálogo já mostra a peça
     ligada, que é como a Éttore vende. O interruptor APAGA. */
  function vira(card, botao, acender) {
    var nome = (card.querySelector('.pc-nome') || {}).textContent || 'a peça';
    card.classList.toggle('apagado', !acender);
    /* ⚠️ O BOTÃO É OPCIONAL desde 21/08: os cartões não desenham mais o
       interruptor, só o topo da categoria tem um. Sem esta guarda, o geral
       lançava TypeError no primeiro cartão e parava de virar os demais —
       falha silenciosa no console, grade inteira sem responder. */
    if (!botao) return;
    botao.setAttribute('aria-pressed', acender ? 'true' : 'false');
    botao.setAttribute('aria-label', (acender ? 'Apagar ' : 'Acender ') + nome);
  }

  document.addEventListener('click', function (e) {
    /* ---- um card ---- */
    var b = e.target.closest && e.target.closest('.pc-luz');
    if (b) {
      /* ⚠️ SÓ `.pc`, E O `return` ABAIXO É PROPOSITAL — não é esquecimento.
         Em 16/08 eu achei que fosse um defeito: na página de produto o mesmo
         botão vive dentro de `<figure class="acende">`, sem `.pc` acima, então
         `closest('.pc')` devolve null e este listener desiste. "Consertei"
         aceitando `.acende` também — e QUEBREI o interruptor da página de
         produto, que funcionava.

         O motivo: a página de produto JÁ tem o seu próprio listener, inline no
         ettore-produto-js.liquid. Com os dois ligados, um clique era tratado
         duas vezes: o inline punha `.apagado` e virava o `aria-pressed`; este
         aqui lia o aria JÁ VIRADO, concluía o contrário e tirava a classe de
         volta. Adicionava e removia no mesmo clique — o botão parecia morto,
         e nenhum dos dois estava errado sozinho.

         Medido: aria-pressed voltava a "true" e a figure ficava sem `.apagado`.
         Quem manda na galeria do produto é o JS inline dela. Este arquivo é
         dos CARDS. */
      var card = b.closest('.pc');
      if (!card) return;
      e.preventDefault();
      /* o .pc-cobre é um link que cobre o card inteiro: sem parar aqui, o
         clique no interruptor navega para a página do produto */
      e.stopPropagation();
      vira(card, b, b.getAttribute('aria-pressed') !== 'true');
      return;
    }

    /* ---- o interruptor GERAL ----
       dirige os cards em vez de ter lógica própria: clicar nele é o mesmo que
       clicar em cada botão, então os dois nunca discordam. Opera só na seção
       onde está, para uma página com duas vitrines não acender as duas. */
    var g = e.target.closest && e.target.closest('[data-luz-geral]');
    if (!g) return;
    var acender = g.getAttribute('aria-pressed') !== 'true';
    g.setAttribute('aria-pressed', acender ? 'true' : 'false');
    var lbl = g.querySelector('[data-luz-lbl]');
    if (lbl) lbl.textContent = rotuloLuz(g, acender);
    var escopo = g.closest('.shopify-section') || document;
    /* 🔴 O `if (bt)` FOI EMBORA EM [2026-08-21], e é a razão desta nota.
       O geral "dirigia os cards clicando no botão de cada um" — desenho bom
       enquanto TODO cartão tinha botão. Ele mandou tirar o interruptor de
       dentro dos cartões nesse dia (*"pode deixar apenas no topo da
       categoria"*), e como `bt` passou a ser sempre `null`, o `if` engolia
       todas as chamadas: o geral virava e não acontecia NADA na grade.
       Medido logo depois de remover: 18 cartões, 0 apagados após o clique.
       Agora o geral age direto na classe do cartão, e o botão — quando
       existir — só acompanha. */
    escopo.querySelectorAll('.pc').forEach(function (c) {
      vira(c, c.querySelector('.pc-luz'), acender);
    });
    guarda(acender);
  });

  /* ═══ O ESTADO ATRAVESSA AS PÁGINAS — [2026-08-25] ═══════════════════════════
     🔑 TRAZIDO DO MECANISMO DA IN COMMON WITH, que ele mandou estudar. Lá o
       interruptor guarda `collectionLighting: lights_on` no localStorage, e é
       isso que faz a coisa parecer um INTERRUPTOR DA CASA e não um botão de
       página: quem apaga a luz e navega para outra categoria continua com a
       luz apagada. Sem isso, cada página recomeça acesa e o gesto se perde.
     🪤 `localStorage` estoura em navegação privada de alguns aparelhos — daí o
       try/catch nos dois lados. Falhar aqui não pode derrubar o interruptor. */
  var CHAVE = 'ettore-luz-grade';
  function guarda(acesa) {
    try { localStorage.setItem(CHAVE, acesa ? 'acesa' : 'apagada'); } catch (e) {}
  }
  function restaura() {
    var v = null;
    try { v = localStorage.getItem(CHAVE); } catch (e) {}
    if (v !== 'apagada') return;          /* o padrão é acesa: nada a fazer */
    document.querySelectorAll('[data-luz-geral]').forEach(function (g) {
      g.setAttribute('aria-pressed', 'false');
      var lbl = g.querySelector('[data-luz-lbl]');
      if (lbl) lbl.textContent = rotuloLuz(g, false);
      var escopo = g.closest('.shopify-section') || document;
      escopo.querySelectorAll('.pc').forEach(function (c) {
        /* ⚠️ SEM TRANSIÇÃO NA RESTAURAÇÃO: a página não deve "apagar sozinha"
           na frente de quem chega — ela já nasce apagada. A classe entra antes
           da primeira pintura quando dá, e a `.sem-transicao` cobre o resto. */
        c.classList.add('sem-transicao');
        vira(c, c.querySelector('.pc-luz'), false);
      });
    });
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        document.querySelectorAll('.pc.sem-transicao').forEach(function (c) {
          c.classList.remove('sem-transicao');
        });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restaura);
  } else {
    restaura();
  }
  /* 🪤 A grade se REDESENHA na categoria (filtro, ver-mais, paginação) e os
     cartões novos nascem acesos. Mesma armadilha do ouvinte preso a elemento:
     quem chega depois precisa herdar o estado. */
  document.addEventListener('ettore:grade-redesenhada', restaura);
})();
